<template>
  <div class="disclaimer p-3" v-if="filteredMessages.length">
    <hr />
    <p v-for="(msg, index) in filteredMessages" :key="index">{{ msg }}</p>
  </div>
</template>

  
  <script>
export default {
  name: "disclaimer",
  props: {
    msg: String,
    page: String,
    commonMsg: {
      type: String,
      default: "9Platforms Technology Pvt. Ltd. All rights reserved"
    }
  },
  data() {
    return {
      message1: "",
      message2: "",
      message3: ""
    };
  },
  computed: {
    filteredMessages() {
      // Filter out messages that include commonMsg (case-insensitive)
      return [this.message1, this.message2, this.message3].filter(msg => {
        return msg && !msg.toLowerCase().includes(this.commonMsg.toLowerCase());
      });
    }
  },
  mounted() {
    const configData2 = this.$store.state.configData.DISCLAIMER;
    const item = configData2?.find(item => item.Page === this.page);
    if (item) {
      this.message1 = item.Message1?.replaceAll('*', '') || '';
      this.message2 = item.Message2?.replaceAll('*', '') || '';
      this.message3 = item.Message3?.replaceAll('*', '') || '';
    }
  }
};
</script>

  
  <style scoped lang="scss">
  @import "../../assets/scss/components/multi-quotes.scss";
    .disclaimer{
      p{
        font-size: 14px;
        padding-bottom: 32px;
      }
    }
    .dark{
      .disclaimer {
        p{
          color: $commonColor !important;
        }
      }
    }
  </style>
  